export default {
    chatPanelNoConsumes: {
        flex: 1,
        backgroundColor: '#282828',
        marginTop: 8,
    },
    chatPanel: {
        flex: 1,
        backgroundColor: '#282828',
        marginTop: 4,
    },
};
